import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {CredentialToken} from '../models/authorization';
import {Environment} from '../constants';
import {environment} from '../environments/enviroment';
import { jwtDecode } from 'jwt-decode';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationService {
  private domain = `${environment.mindxbkUrl}Auth/Authenticate`;
  private username = Environment.username;
  private password = Environment.password;
  private tokenSubject = new BehaviorSubject<string | null>(null);
  sessionSubj = new BehaviorSubject<string | null>(null);
  session$ = this.sessionSubj.asObservable();

  constructor(
    private http: HttpClient,
  ) {
  }

  get token$(): Observable<string | null> {
    return this.tokenSubject.asObservable();
  }

  getTokenFromStorage(): string | null {
    const token = localStorage.getItem('auth_req');
    return token;
  }

  // get tokenOptimized(): Observable<string> {
  //   const current_token = localStorage.getItem('auth_req');

  //   // check if exits token
  //   if (!current_token) {
  //     // If no token exists, return null or fetch a new token
  //     return this.getToken();
  //   }

  //   // check expiration  auth_req `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJBeGVkZSIsInJvbGUiOiJXZWJzaXRlIiwiZXhwIjoxNzU2NDM0ODU3fQ.2CFP9IOAKggzGZKMB9XdlY_kq3QLRxE8ginrJOoIc2U`

  //   // const payload = JSON.parse(atob(current_token.split('.')[1]));
  //   // const exp = payload.exp;

  //   // if (Date.now() >= exp * 1000) {
  //   //   // If token is expired, fetch a new token
  //   //   return this.getToken();
  //   // }

  // }

  getToken(): Observable<string> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      Accept: 'application/json',
    });

    const body = new HttpParams()
      .set('username', this.username)
      .set('password', this.password);

    return this.http
      .post<CredentialToken>(this.domain, body.toString(), { headers })
      .pipe(
        tap((credentials) => {
          this.tokenSubject.next(credentials.access_token);
          localStorage.setItem('auth_req', credentials.access_token);
        }),
        map((credentials) => credentials.access_token)
      );
  }

  refreshToken(): Observable<string> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      Accept: 'application/json',
    });
    const body = new HttpParams()
      .set('username', this.username)
      .set('password', this.password);

    return this.http
      .post<CredentialToken>(this.domain, body.toString(), { headers })
      .pipe(
        tap((credentials) => {
          this.tokenSubject.next(credentials.access_token);
          localStorage.setItem('auth_req', credentials.access_token);
        }),
        map((credentials) => credentials.access_token)
      );
    }


  isAuthenticated(): boolean {
    const token = localStorage.getItem('token');
    if (!token) {
      return false;
    }

    try {
      const payload: any = jwtDecode(token);
      const exp = Number(payload?.exp || 0);
      return !!exp && Date.now() < (exp * 1000);
    } catch {
      return false;
    }
  }

}
